<template>
  <v-container fluid class="grey lighten-5">
    <v-card
      elevation="5">

      <v-row class="text-center">
        <v-col col="12">
          <h1 class="font-weight-bold text-h4 mb--1 pa-12">
            Acerca de INNUVEX</h1>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-img
        :src="require('../../assets/about-img.jpg')"
        height="200px"
      >
      </v-img>

        <v-row class="justify">
          <v-col col="12">
            <div class="markdown-body">
              <v-card-title>QUIENES SOMOS</v-card-title>
              <blockquote class="blockquote">
              <p>
                Somos una empresa panameña dedicada a ofrecer servicios tecnológicos eficientes,
                soluciones integrales y de alta calidad, utilizando las tecnologías emergentes
                logramos optimizar los procesos de cualquier tipo de negocio. Nos apasiona lo que hacemos.
                No somos solo una empresa que vende páginas web, nuestro objetivo es ayudar a nuestros clientes
                a alcanzar todo su potencial.
              </p>
              </blockquote>
            </div>
          </v-col>
        </v-row>

        <v-row class="justify">
          <v-col col="12">
            <div class="markdown-body">
              <v-card-title class="nosotros-content">nuestra filosofía</v-card-title>
              <blockquote class="blockquote">
              <p>
                En <strong>INNUVEX</strong> promovemos el crecimiento del talento local, brindamos la oportunidad a
                los nuevos desarrolladores de participar en nuestros proyectos para que obtengan la experiencia
                que ayude a formar su carrera profesional o emprendimiento.
              </p>
              </blockquote>
            </div>
          </v-col>
        </v-row>
        <v-row class="justify">
          <v-col col="12">
            <div class="markdown-body">
              <v-card-title class="nosotros-content">misión</v-card-title>
              <blockquote class="blockquote">
              <p>
                Brindar a nuestros clientes soluciones integrales de alta calidad,
                siendo una empresa innovadora que les permita alcanzar su máximo potencial.
              </p>
              </blockquote>
            </div>
          </v-col>

          <v-col col="12">
            <div class="markdown-body">
              <v-card-title class="nosotros-content">visión</v-card-title>
              <blockquote class="blockquote">
              <p>
                Ser líderes en el desarrollo de
                <span style="text-decoration: underline;">Soluciones Integrales</span>
                utilizando las tecnologías emergentes
                logrando así una ventaja competitiva sostenible para nuestros clientes.
              </p>
              </blockquote>
            </div>
          </v-col>
        </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { mdiAccountGroupOutline } from '@mdi/js'
export default {
  data () {
    return {
      icon: {
        about: mdiAccountGroupOutline
      }
    }
  }
}
</script>

<style scoped>
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
.nosotros-content {
  text-transform: uppercase;
}
</style>
